<!-----------------------------------------------------------------------------------------------------------
  || Type of Props in this Component ||                              
  The Props are in Tailwind CSS V2 class 
    #1 - Position of Tooltip           
      1ª - bottom: top-full left-2/4 (mt-2)          
      2ª - top: bottom-full left-2/4  (mb-2)
      3ª - right: top-0 left-full (-mt-1 ml-2)
      4ª - left: top-0 right-full (-mt-1 mr-2)
    #2 - Background Color - (Dark: bg-blueGary-800 text-gray-200 \\ White: bg-white text-blueGray-800)
    #3 - Width
    #4 - Text Align
    #5 - Margin Left || Margin Right 
    #6 - Text Color - (Dark: text-gray-200 \\ White: text-blueGray-800)

  It is possible to add any class to the element, these are just recommendations to keep the design coherent 
  Example of use: 
    <Tooltip :text="'Add by Teacher'" styleTooltip="bottom-full left-2/4 w-32 -ml-16 mb-1" backgroundColor="bg-gray-500" textColor="text-xs text-gray-100">
      <button><i class="fa-solid fa-chalkboard-user text-xs mr-2 text-green-600"></i></button>
    </Tooltip>       
--------------------------------------------------------------------------------------------------------------->

<template>
  <div @mouseover="isHover = true" @mouseleave="isHover = false" :class="positionTooltip" style="lineheight: 5px">
    <slot />
    <div v-if="isHover" :class="[backgroundColor, styleTooltip, padding]" class="absolute z-10 rounded-md text-center font-manrope">
      <span v-html="text" style="font-size: 13px" :class="[textColor]" class="text-white block whitespace-nowrap font-normal"></span>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  export default Vue.extend({
    name: "Tooltip",
    data() {
      return {
        isHover: false,
      };
    },
    props: {
      text: String,
      backgroundColor: {
        type: String,
        default: 'bg-blueGray-800'
      },
      width: String,
      styleTooltip: {
        type: String,
        default: 'top-0 left-full ml-4 -mt-0.5 items-center'
      },
      textColor: {
        type: String,
        default: 'text-gray-100'
      },
      padding: {
        default: 'py-1.5 px-2.5',
      },
      positionTooltip: {
        type: String,
        default: 'relative',
      },
    },
  });
</script>



// WEBPACK FOOTER //
// Tooltip.vue?5820b3da